import { render } from "./Sbus.vue?vue&type=template&id=3f911914"
import script from "./Sbus.vue?vue&type=script&lang=js"
export * from "./Sbus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__